export const agentName = (a) => a?.chosen_name || a?.working_name || a?.emp_no || "";

export function shapesOf(a) {
  const s = a?.chosen_shape;
  const list = Array.isArray(s) ? [...s] : s === "both" ? ["chatbot", "form"] : s ? [s] : [];
  if (a?.scheduled && !list.includes("scheduled")) list.push("scheduled");
  const on = a?.shape_enabled || {};
  return list.filter((x) => !(x === "chatbot" && on.chat === false) && !(x === "form" && on.form === false));
}

export const statusOf = (e) => (e?.live ? (e.scheduled ? "scheduled" : "live") : "soon");

export function modesFor(entity, kind) {
  if (kind === "workflow") return ["workflow"];
  const shapes = shapesOf(entity);
  const on = entity?.shape_enabled || {};
  const modes = [];
  if (shapes.includes("chatbot")) modes.push("chat");
  if (shapes.includes("form")) modes.push("form");
  if (modes.length) return modes;
  return on.chat === false ? (on.form === false ? [] : ["form"]) : ["chat"];
}

export const workflowsForAgent = (a, workflows) =>
  workflows.filter((w) => (a.workflows || []).includes(w.id) || (w.agents || []).includes(a.working_name));

export const subAgentsOf = (a, agents) => agents.filter((x) => x.parent && x.parent === a.working_name);

export const agentByWorkingName = (name, agents) => agents.find((a) => a.working_name === name);

export function targetName(id, agentsByKey, workflowsByKey) {
  if (!id || id === "any") return "Any agent";
  return workflowsByKey[id]?.name || agentName(agentsByKey[id]) || id;
}

export const targetPath = (id, workflowsByKey) => (workflowsByKey[id] ? `/workflows/${id}` : `/agents/${id}`);

export const isRequired = (v) => v === true || String(v).toUpperCase() === "REQUIRED" || String(v).toLowerCase() === "yes";

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    ta.remove();
    return ok;
  }
}
